export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
  },
};

// Mobile-specific breakpoint for our constrained app
export const mobileMaxWidth = 428;

/**
 * Responsive max-width pattern for content containers.
 * - Mobile (xs): Full-width (no gutters)
 * - Desktop (md+): Constrained to 600px for better UX
 *
 * Use this with MUI Container or Box sx prop:
 * @example
 * <Container sx={{ maxWidth: RESPONSIVE_CONTENT_MAX_WIDTH }}>
 * <Box sx={{ maxWidth: RESPONSIVE_CONTENT_MAX_WIDTH }}>
 */
export const RESPONSIVE_CONTENT_MAX_WIDTH = { xs: '100%', md: 600 };
